import {createContext, ReactNode, useContext} from 'react';

/**
 * Handler for link clicks inside rendered message text. Return true when the
 * click was handled by the app (navigation will be prevented); return false
 * to let the browser handle the link normally.
 */
export type MessageLinkClickHandler = (href: string) => boolean;

const MessageLinkInterceptContext =
  createContext<MessageLinkClickHandler | null>(null);

export function MessageLinkInterceptProvider({
  onMessageLinkClick,
  children,
}: {
  onMessageLinkClick: MessageLinkClickHandler;
  children: ReactNode;
}) {
  return (
    <MessageLinkInterceptContext.Provider value={onMessageLinkClick}>
      {children}
    </MessageLinkInterceptContext.Provider>
  );
}

export function useMessageLinkIntercept(): MessageLinkClickHandler | null {
  return useContext(MessageLinkInterceptContext);
}
